import _defineProperty from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React, { forwardRef } from 'react';
import { useUuid, useBooleanToggle } from '@mantine/hooks';
import { useMantineTheme, useExtractedMargins } from '@mantine/styles';
import { ActionIcon } from '../ActionIcon/ActionIcon.js';
import { PasswordToggleIcon } from './PasswordToggleIcon.js';
import useStyles from './PasswordInput.styles.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { Input } from '../Input/Input.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var buttonSizes = {
  xs: 22,
  sm: 28,
  md: 26,
  lg: 32,
  xl: 40
};
var iconSizes = {
  xs: 12,
  sm: 15,
  md: 17,
  lg: 19,
  xl: 21
};
var rightSectionSizes = {
  xs: 28,
  sm: 34,
  md: 34,
  lg: 44,
  xl: 54
};
var PasswordInput = forwardRef(function (_a, ref) {
  var _cx;
  var _b = _a,
    _b$radius = _b.radius,
    radius = _b$radius === void 0 ? "sm" : _b$radius,
    disabled = _b.disabled,
    _b$size = _b.size,
    size = _b$size === void 0 ? "sm" : _b$size,
    _b$toggleTabIndex = _b.toggleTabIndex,
    toggleTabIndex = _b$toggleTabIndex === void 0 ? -1 : _b$toggleTabIndex,
    className = _b.className,
    id = _b.id,
    label = _b.label,
    error = _b.error,
    required = _b.required,
    style = _b.style,
    icon = _b.icon,
    description = _b.description,
    wrapperProps = _b.wrapperProps,
    classNames = _b.classNames,
    styles = _b.styles,
    variant = _b.variant,
    _b$visibilityToggleIc = _b.visibilityToggleIcon,
    VisibilityToggleIcon = _b$visibilityToggleIc === void 0 ? PasswordToggleIcon : _b$visibilityToggleIc,
    _b$__staticSelector = _b.__staticSelector,
    __staticSelector = _b$__staticSelector === void 0 ? "PasswordInput" : _b$__staticSelector,
    _rightSection = _b.rightSection,
    _rightSectionWidth = _b.rightSectionWidth,
    _rightSectionProps = _b.rightSectionProps,
    sx = _b.sx,
    others = __objRest(_b, ["radius", "disabled", "size", "toggleTabIndex", "className", "id", "label", "error", "required", "style", "icon", "description", "wrapperProps", "classNames", "styles", "variant", "visibilityToggleIcon", "__staticSelector", "rightSection", "rightSectionWidth", "rightSectionProps", "sx"]);
  var theme = useMantineTheme();
  var rightSectionWidth = theme.fn.size({
    size: size,
    sizes: rightSectionSizes
  });
  var _useStyles = useStyles({
      size: size,
      rightSectionWidth: rightSectionWidth
    }, {
      name: "PasswordInput"
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var uuid = useUuid(id);
  var _useExtractedMargins = useExtractedMargins({
      others: others,
      style: style
    }),
    mergedStyles = _useExtractedMargins.mergedStyles,
    rest = _useExtractedMargins.rest;
  var _useBooleanToggle = useBooleanToggle(false),
    _useBooleanToggle2 = _slicedToArray(_useBooleanToggle, 2),
    reveal = _useBooleanToggle2[0],
    toggle = _useBooleanToggle2[1];
  var rightSection = /* @__PURE__ */React.createElement(ActionIcon, {
    tabIndex: toggleTabIndex,
    radius: radius,
    size: theme.fn.size({
      size: size,
      sizes: buttonSizes
    }),
    "aria-hidden": "true",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggle();
    },
    onKeyDown: function onKeyDown(event) {
      if (event.nativeEvent.code === "Space") {
        event.preventDefault();
        toggle();
      }
    }
  }, /* @__PURE__ */React.createElement(VisibilityToggleIcon, {
    reveal: reveal,
    size: theme.fn.size({
      size: size,
      sizes: iconSizes
    })
  }));
  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: mergedStyles,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    sx: sx
  }, wrapperProps), /* @__PURE__ */React.createElement(Input, {
    component: "div",
    required: required,
    invalid: !!error,
    icon: icon,
    size: size,
    classNames: __spreadProps(__spreadValues({}, classNames), {
      input: cx(classes.input, classNames == null ? void 0 : classNames.input)
    }),
    styles: styles,
    radius: radius,
    disabled: disabled,
    __staticSelector: __staticSelector,
    rightSectionWidth: rightSectionWidth,
    rightSection: !disabled && rightSection,
    variant: variant
  }, /* @__PURE__ */React.createElement("input", __spreadValues({
    type: reveal ? "text" : "password",
    className: cx(classes.innerInput, (_cx = {}, _defineProperty(_cx, classes.withIcon, icon), _defineProperty(_cx, classes.invalid, !!error), _cx)),
    disabled: disabled,
    id: uuid,
    ref: ref
  }, rest))));
});
PasswordInput.displayName = "@mantine/core/PasswordInput";
export { PasswordInput };